var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRightArrowWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m34.031 25.078-7.5 7.5c-.562.61-1.547.61-2.11 0a1.445 1.445 0 0 1 0-2.11l4.923-4.968H15a1.48 1.48 0 0 1-1.5-1.5c0-.797.656-1.5 1.5-1.5h14.344l-4.922-4.922a1.445 1.445 0 0 1 0-2.11 1.445 1.445 0 0 1 2.11 0l7.5 7.5c.609.563.609 1.548 0 2.11"
})));
export default SvgRightArrowWhite;